import i18n from 'i18next';

var errors;
const revenues=['revenues1', 'revenues2', 'revenues3'];
const ebit=['ebit1', 'ebit2', 'ebit3'];
const netIncome=['netIncome1', 'netIncome2', 'netIncome3'];

function validate0(values) {
  errors = {} ;
  if (!values.currency) {
    errors.currency = i18n.t('error_message');
  }
  if (!values.latestYear) {
    errors.latestYear = i18n.t('error_message');
  }
  // console.log('errors--->',errors);
  return errors;
};

function name_i(i, values) {
  errors = {} ;
  [revenues[i], ebit[i], netIncome[i]].map(x=>{
    if (!values[x]) {
      errors[x] = i18n.t('error_message');;
    }
  })
  
  return errors;
};


function validate1(values) {
  return name_i(0, values);
};

function validate2(values) {
  return name_i(1, values);
};
function validate3(values) {
  return name_i(2, values);
};
function validate4(values) {
  errors = {} ;
  // if (!values.owner) {
  //   errors.owner = errorMessage;
  // }

  // console.log(values);
  return errors;
};

function validateMail(values) {
  errors = {} ;
  if (!values.email) {
    errors.email = i18n.t('error_message');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = i18n.t('invalid_email');
  }
  return errors
}

export {validate0, validate1, validate2, validate3, validate4, validateMail };

